import React from 'react';
import { CtaBlock } from '../CtaButton';
import { MOCKUP_URL } from '../../data/images';

/** Section 12 — the price reveal and the checkout button. */
export function CheckoutSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-56" data-mp="1tr73jbpe4ezo">
      <div className="mx-auto max-w-3xl rounded-[28px] bg-brand-plum-dark px-6 py-12 text-center text-white shadow-[0_50px_100px_-50px_rgba(59,27,87,0.7)] sm:px-12 lg:py-16" data-id="element-57" data-mp="1otopx80fhblc">
        <h2 id="offer-heading" className="mx-auto max-w-xl font-display text-[2.4rem] font-bold leading-[1.04] sm:text-[3.1rem]" data-id="element-58" data-mp="2hgt1jvu10o63">
          How Much Is Your <em className="font-semibold italic text-brand-lilac" data-id="element-59" data-mp="2ck2jj2ynvii1">Preparation Time</em> Worth?
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-white/75 sm:text-[16px]" data-id="element-60" data-mp="1132x2nyzvxvx">
          Creating lesson structures, exercises, practice resources, assessments and classroom materials from
          scratch can consume hours of work. Makeup Instructor Ready puts an entire professional teaching
          system in one place.
        </p>

        <div className="mx-auto mt-10 rounded-[20px] bg-brand-ivory px-4 pb-6 pt-5" data-id="element-61" data-mp="35h2zjg26xj3f">
          <img src={MOCKUP_URL} alt="Makeup Instructor Ready — the six core volumes with real pages on tablet, laptop and phone" width={1536} height={1024} loading="lazy" decoding="async" className="block w-full object-contain" data-id="element-62" data-mp="2rh1x3w6a23lu" />
          <p className="mt-4 font-body text-[13px] font-bold uppercase tracking-[0.16em] text-brand-plum" data-id="element-63" data-mp="2mktm8uz44wkh">
            6 Core Volumes <span className="text-brand-gold" data-id="element-64" data-mp="2csxcgmnnzi0f">+</span> 5 Extra Bonuses
          </p>
        </div>

        <p className="mt-10 font-body text-[12px] font-semibold uppercase tracking-[0.2em] text-brand-lilac" data-id="element-65" data-mp="1yt616toj8fq4">Only</p>
        <p className="mt-1 font-body font-bold leading-none tracking-[-0.01em]" data-id="element-66" data-mp="23sr1b7ffuu4f">
          <span className="text-[4rem] sm:text-[4.75rem]" data-id="element-67" data-mp="9c0ph7f9pmr4">$27</span>
          <span className="ml-2 text-[1.25rem] text-white/65" data-id="element-68" data-mp="9dbt978pqui8">USD</span>
        </p>
        <p className="mt-3 font-body text-[12px] font-semibold uppercase tracking-[0.2em] text-white/75" data-id="element-69" data-mp="4kirms8jk2ad">
          One-Time Payment
        </p>

        <div id="offer-cta" className="scroll-mt-24" data-id="element-70" data-mp="3rq09g8b20cf5">
          <CtaBlock label="Yes! Give Me Instant Access Now" action="checkout" tone="light" note="Instant Digital Access • No Subscription" className="mt-8" data-id="element-71" data-mp="3rrbeebg8jq7u" />
        </div>
      </div>
    </section>;
}